/*
 * @Author: DT
 * @Date: 2022-10-19 09:38:52
 * @LastEditors: DT
 * @LastEditTime: 2022-11-09 19:10:56
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/returnGoods/photoList/photoList.js
 */
import { driverTakeImgsApi } from "@/libs/api";
export default {
  data() {
    return {
      listStatus: 1,
      show: false,
      index: 0,
      images: "",
      imagesList: [],
    };
  },
  mounted() {
    window.dsBridge &&
      window.dsBridge.call("setNativeTitle", {
        title: "",
      });
    console.log("id=======", this.$route.query.id);
    this.$toast.loading({
      duration: 0,
      mask: true,
      message: "加载中...",
    });
    console.log('this.$cookies.get("ul_utk")', this.$cookies.get("ul_utk"));
    this.getPhotos(this.$route.query.id);
  },
  methods: {
    onChange(index) {
      this.index = index;
    },
    handleShowPhoto(index) {
      this.index = index;
      this.show = true;
    },
    closePop(e) {
      console.log(e);
      this.show = false;
    },
    getPhotos(id) {
      driverTakeImgsApi({ id })
        .then((res) => {
          if (res.returnCode == "0000") {
            if (res.result && res.result.imgs) {
              this.images = res.result.imgs;
              if (this.images) {
                this.imagesList = this.images.split(",");
              }
              this.listStatus = 2;
            } else {
              this.listStatus = 3;
            }
          } else {
            this.listStatus = 3;
          }
          this.$toast.clear();
        })
        .catch(() => {
          this.listStatus = 3;
        });
    },
  },
};
